import { Language } from '../translations/types';

const STORAGE_KEY = 'mirolumo_language';

export const detectBrowserLanguage = (): Language => {
  // Get browser language
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  
  // Extract the language code (e.g., 'en-US' → 'en')
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Map to supported languages
  switch (langCode) {
    case 'de':
      return 'de';
    case 'es':
      return 'es';
    case 'fr':
      return 'fr';
    case 'en':
    default:
      return 'en'; // Default to English
  }
};

export const getStoredLanguage = (): Language | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && ['de', 'en', 'es', 'fr'].includes(stored)) {
      return stored as Language;
    }
  } catch (error) {
    console.error('Error reading language from localStorage:', error);
  }
  return null;
};

export const storeLanguage = (language: Language): void => {
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch (error) {
    console.error('Error storing language in localStorage:', error);
  }
};

export const getInitialLanguage = (): Language => {
  // First check if user has a stored preference
  const storedLang = getStoredLanguage();
  if (storedLang) {
    return storedLang;
  }
  
  // Otherwise detect from browser
  return detectBrowserLanguage();
};